<template>
    <main role="main">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="page-con">
            <div class="page-list-con no-bn research">
                <h2>{{ $t('HEADER.PROJECTS') }}</h2>
                <div v-if="isLoading" style="min-height:600px">
                </div>
                <div>
                    <ol class="research-tabs">
                        <li :class="{ active: 'all' == activeCategory  }" @click="SwitchCategory('all')">{{ $t('CATEGORY.ALL') }}</li>
                        <li :class="{ active: item.id == activeCategory }" v-for="(item) in section.list" :key="item.id" @click="SwitchCategory(item.id)">{{item.name}}</li>
                    </ol>

                    <div class="oops" v-if="datas.length == 0 && !isLoading">
                        <img src="../../../static/images/10/oops.png" alt="">
                    </div>

                    <div class="single-item" >

                        <div class="item-box" v-for="(item,index) in banners" :key="item.id" :id="index"
                        style="background-position: top center;
                        background-repeat: no-repeat;
                        background-size: cover;
                        image-rendering: -webkit-optimize-contrast;
                        width: 100%;"
                        :style="{ 'background-image': 'url('+ item.data.src+')' }" 
                        @click="Go(item.data.link != '' ? item.data.link : '/research/' + item.id)"
                        >
                            <p class="time-box"><span>{{item.data.day}}</span>{{item.data.yearmonth}}</p>
                            
                            <div class="item-txt">
                            <p>{{item.data.category_name}}</p>
                            <h5>{{item.data.title}}</h5>
                            </div>
                        </div>
                    </div>

                    <ul class="research-con-box">
                        <li v-for="(item) in ShowData" :key="item.id" >
                            <a :href="item.data.link != '' ? item.data.link : '/research/' + item.id" :target="item.data.link  != '' ? '_blank' : false">
                                <div class="research-img-box">
                                    <div class="time-box">
                                    <p><span>{{item.data.day}}</span>{{item.data.yearmonth}}</p>
                                    </div>
                                    <div class="research-img" :style="{ 'background-image': 'url('+ item.data.src+')' }" ></div>
                                </div>
                                <div  class="research-txt-box">
                                    <p>{{item.data.category_name}}</p>
                                    <h5>{{item.data.title}}</h5>
                                    <i></i>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <Pagination :dataLength="datas.length" :rowPageCount="12" @start="getStart" @end="getEnd"></Pagination>
            </div>
            
        </div>
        <IndexFooter></IndexFooter>
    </main>
</template>
<script>
import {fb, db } from '../../firebase'
import Slick from 'vue-slick';

export default {
  name: 'Research',
  components: { Slick },
    data () {
        return {
            slickOptions: {
                dots:true,
                centerMode: true,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        
                        settings: {
                        arrows: false,
                        centerMode: true,
                        
                        slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                        arrows: false,
                        centerMode: true,
                        //centerPadding: '40px',
                        slidesToShow: 4
                        
                        }
                    }]
                // Any other options that can be got from plugin documentation
            },
            tmp:[],
            banners:[],
            datas:[],
            section:{},
            activeCategory:'all',
            isLoading: false,
            fullPage: true,
            start:0,
            end:0
        }
    },
    computed: {
        ShowData: function () {
            return this.datas.slice(this.start-1, this.end-1);
        }
    },
    mounted () {
        this.GetCategory();
    },
    methods: {
        FindName(selected) {
            if (this.section.list.find(x=>x.id == selected))
                return this.section.list.find(x=>x.id == selected).name;
            else 
                return ''
            
        },
        GetCategory() {
            this.isLoading = true;
            db.collection(this.$t('DB.CATEGORY')).doc('research').get().then((doc) => {
                if (doc.exists) {
                    this.section = doc.data();
                    this.section.list.sort( (d1, d2) => d2.order - d1.order);
                    this.Get();
                } 
            }).catch((error) => {
                console.log("Error getting document:", error);
                this.isLoading = false;
            });
            
        },
        Get(){
            var vm = this;
            // 取得列表
            db.collection(this.$t('DB.NEWS')).where('selected', '==', 'research').get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                        var item = doc.data();
                        var yearmonth = doc.data().date.substr(0,7);
                        var day = doc.data().date.substr(8,2);
                        item.yearmonth = yearmonth;
                        item.day = day;

                        
                        item.category_name =  this.FindName(doc.data().list_selected);
                        var data = {"id": doc.id, "data": item};
                        this.datas.push(data);
                });
                this.datas.sort( (d1, d2) => d2.data.order - d1.data.order);
                this.banners = this.datas.slice(0, 3);
                this.tmp = this.datas;
                this.isLoading = false;
               
                setTimeout(function(){
                    $('.single-item').slick({
                        dots: true,
                        autoplay: true,
                        autoplaySpeed: 3000,
                    });
                }, 200)
        
            }).catch((error) => {
                console.log("Error getting document:", error);
                this.isLoading = false;
            });
        },
        Switch(index ) {
            this.pagination.activePage = index;
            window.scrollTo({top: 0,behavior: 'smooth'})
        },
        SwitchCategory(id){
  
            if ( id == 'all') this.datas = this.tmp;
            else    this.datas = this.tmp.filter(x => x.data.list_selected == id);
            this.activeCategory = id;
                
            this.reInit();


        },
        Go(link){
            window.open(link, '_blank')
        },
        getStart(val){
            this.start = val;
        },
        getEnd(val){
            this.end = val;
        },
        reInit() {
            
            $('.single-item').slick('unslick');

            this.banners = this.datas.slice(0, 3);
            var vm = this;
            setTimeout(function(){
                if ( vm.banners.length > 0 ) $('.item-box').first().css('background-image', 'url('+ vm.banners[0].data.src +')');
                if ( vm.banners.length > 1 ) $('.item-box:eq(1)').css('background-image', 'url('+ vm.banners[1].data.src +')');
                if ( vm.banners.length > 2 ) $('.item-box:eq(2)').css('background-image', 'url('+ vm.banners[2].data.src +')');

    
                $('.single-item').slick({
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                });
            },200)
        
        }

        
    }
}
</script>
<style scoped>
a.disabled {
  pointer-events: none;
  cursor: default;
}
.item-box{
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/index/Research.vue